import { useEffect, useState } from "react";
import { app } from "@microsoft/teams-js";
import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  container: {
    padding: "1.5rem",
    width: "100%"
  }
})

export default function HowTo() {
  const styles = useStyles();
  const [userLang, setUserLang] = useState<string>('en');

  useEffect(() => {
    app.getContext().then((context) => {
      setUserLang(context?.app?.locale.substring(0 ,2) ?? 'en');
    });
  }, []);

  return (
    <div className={styles.container}>
      {userLang === 'de' && (
        <>
          <h1>Anleitung</h1>
          <p>
            Sobald Sie die 3SS-App in Teams heruntergeladen haben, müssen Sie sie mit Ihrem 3SS-Konto verknüpfen.
          </p>
          <ul>
            <li>Öffnen Sie die 3SS-Anwendung.</li>
            <li>Navigieren Sie zu Ihrem Profil oben rechts und klicken Sie auf das Dropdown-Menü.</li>
            <li>Wählen Sie „Konten verknüpfen“.</li>
          </ul>
          <hr />
        </>
      )}
      
      {userLang === 'fr' && (
        <>
          <h1>Instructions</h1>
          <p>
            Une fois que vous avez téléchargé l’application 3SS dans Teams, vous devez la lier à votre compte 3SS.
          </p>
          <ul>
            <li>Ouvrez l’application 3SS.</li>
            <li>Accédez à votre profil en haut à droite et cliquez sur le menu déroulant.</li>
            <li>Sélectionnez « Lier les comptes ».</li>
          </ul>
          <hr />
        </>
      )}

      {userLang === 'en' && (
        <>
        <h1>How To</h1>
        <p>
          Once you have downloaded the 3SS app in Teams you will need to link it to your 3SS account.
        </p>
        <ul>
          <li>Open the 3SS application</li>
          <li>Navigate to your profile in the upper right corner and click on the dropdown</li>
          <li>Select “Link Accounts”</li>
        </ul>
      <hr />
      </>
      )}

      {userLang === 'es' && (
        <>
        <h1>Instrucciones</h1>
        <p>
          Una vez que haya descargado la aplicación 3SS en Teams, deberá vincularla a su cuenta de 3SS.
        </p>
        <ul>
          <li>Abra la aplicación 3SS.</li>
          <li>Vaya a su perfil en la esquina superior derecha y seleccione el menú desplegable.</li>
          <li>Seleccione “Vincular Cuentas”.</li>
        </ul>
        <hr />
        </>
      )}
    </div>
  );
}

